// Photos for THE CLUBHOUSE section. Add, remove or reorder freely —
// the section renders whatever is here. Files live in /public/images.
// size: "large" = full width, "small" = centered and narrower,
// "tall" = portrait shot shown whole, centered, height capped.
// caption is optional; leave it "" for no caption.
//
// CLUBHOUSE_INTRO is the short lead-in line shown above the photos.
// Rewrite it any time; set it to "" to hide the line.
export const CLUBHOUSE_INTRO = "A few exciting weeks out here lately, and it brought the fans out. Great job, boys.";

export const CLUBHOUSE_PHOTOS = [
  {
    src: "/images/fans-clubhouse.jpg",
    alt: "The boys at the clubhouse table after the round with pitchers of beer, a cake and the yellow measuring tape",
    caption: "",
    size: "tall",
  },
  {
    src: "/images/fans-signs.jpg",
    alt: "A crowd of fans holding handmade signs cheering two of the boys as they walk through the gallery",
    caption: "",
    size: "tall",
  },
  {
    src: "/images/fans-autographs.jpg",
    alt: "Fans crowding around the boys for autographs and photos outside the course shed",
    caption: "",
    size: "tall",
  },
];
